import $ from "jquery";

document.documentElement.className = 'js';

var openCtrl = document.querySelectorAll('.search-icon'),
	// openCtrl2 = document.querySelector('.search-loupe-responsive'),
	closeCtrl = document.getElementById('btn-search-close'),
	searchContainer = document.getElementById('container-global-search'),
	inputSearch = searchContainer.querySelector('.search__input');

function init() {
	initEvents();
}


function initEvents() {
	openCtrl.forEach(function (item) {
		item.addEventListener('click', openSearch);
	// openCtrl2.addEventListener('click', openSearch);
	closeCtrl.addEventListener('click', closeSearch);
		document.addEventListener('keyup', function (ev) {
			// escape key.
			if (ev.keyCode === 27) {
				closeSearch();
			}
		});
	});
}

function openSearch(event) {
	event.preventDefault();
	searchContainer.classList.add('search--open');
	setTimeout(function () {
		inputSearch.focus();
	}, 600);
}

function closeSearch() {
	searchContainer.classList.remove('search--open');
	inputSearch.blur();
	inputSearch.value = '';
}

init();

$(function() {
    var ajaxsearch = themeurl + '/ajaxsearch.php';
    /******************************************/
    /*************** FILTRES *************/
    /******************************************/
    var $filters = $('.filters-search');
    var $results = $('#search-results');
    if($results.length > 0){
        var page = 1;
        let loadSearch = function(reset){
            if(reset === true)
                page = 1;
            $results.addClass('loading');        
            var data = {
                'action': 'load_search',
                'search' : $('#thesearch').val(),
                'page': page,
                'sort' : $filters.find('#filter_date_js select').val(),
                'lang' : _lang
            };        
            if($filters.find('input[type=checkbox]:checked')){
                data.types = [];
                $filters.find('input[type=checkbox]:checked').each(function(){
                    data.types.push($(this).val());
                });
            }
            $.post(ajaxsearch, data, function(response) { 
                $results.html(response.results);
                $results.append(response.pagination);
                $results.removeClass('loading');
            });
        }
        // ----- filtre catégorie
        $filters.find('input, select').change(function(){
            loadSearch(true);
        });
        $('body').on('click', '.page-numbers', function(e){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $("#search-results").offset().top - $(".header-sticky").height()
            }, 500);
            if($(this).hasClass('next'))
                page++;
            else if($(this).hasClass('prev'))
                page--;
            else
                page = $(this).html();
            loadSearch(false);
        });
            
        //--- chargement de la page    
        //loadSearch(false);
    }       
    //--- autocomplete  
    var typingTimer;
    $('[data-ac]').each(function(){
        var $acContainer = $(this);
        var $acInput = $acContainer.find('.ac-input');        
        $acInput.on('keyup', function (e) {
            $acContainer.removeClass('loadingsmall');
            if(e.which !== 38 && e.which !== 40 && e.which !== 13){
                clearTimeout(typingTimer);
                acSearch($acInput.val(), $acContainer);
            }
        });
    });
    $('body').click(function(){
        $('.ac-results').remove();
    });

    function acSearch(search, $container){  
        typingTimer = setTimeout(function(){
            $container.addClass('loadingsmall');
            if(search.length > 2){
                $.post(ajaxsearch, {
                    'action': 'load_autocomplete',
                    'search' : search,
                    'lang' : _lang
                }, function(response) { 
                    $container.removeClass('loadingsmall');
                    $container.find('.ac-results').remove();
                    var $results = $(response.results);
                    if($results.length > 0){
                        var $div = $('<div class="ac-results"></div>');
                        $div.html($results);                               
                        $container.append($div );
                    }
                });
            }
            else
            $container.find('.ac-results').remove();
        }, 500);
    }
});
